const CDN_ROOT = 'https://elio-template.cdn.modulify.website/images'

const image = (path: string): string => `${CDN_ROOT}/${path}`

/** SS26 campaign photography, hosted on the project CDN. */
export const media = {
    rainShellHood: image('campaign-ss26/rain-shell-hood.png'),
    concreteStepsSeated: image('campaign-ss26/concrete-steps-seated.png'),
    hoodedCoastStorm: image('campaign-ss26/hooded-coast-storm.png'),
    wetHairConcrete: image('campaign-ss26/wet-hair-concrete.png'),
    strapHardware: image('campaign-ss26/strap-hardware.png'),
    overcastSilhouette: image('campaign-ss26/overcast-silhouette.png'),
    concreteArcCoat: image('campaign-ss26/concrete-arc-coat.png'),
    ledgeOvercast: image('campaign-ss26/ledge-overcast.png'),
    concreteRoomBlack: image('campaign-ss26/concrete-room-black.png'),
    essentialsLineup: image('campaign-ss26/essentials-lineup.png'),
    visorProfile: image('campaign-ss26/visor-profile.png'),
    blackShellPortrait: image('campaign-ss26/black-shell-portrait.png'),
    elioLabelDetail: image('campaign-ss26/elio-label-detail.png'),
    beanieVisorPortrait: image('campaign-ss26/beanie-visor-portrait.png')
}

/** Editorial photography matched to individual sections (chapters, credits, stores, trail). */
export const editorial = {
    nightShiftUmbrella: image('ss26/editorial/night-shift-umbrella.jpg'),
    softArmorColourBlock: image('ss26/editorial/soft-armor-colour-block-knit.jpg'),
    softArmorRibPortrait: image('ss26/editorial/soft-armor-rib-knit-portrait.jpg'),
    concreteCourtyardPair: image('ss26/editorial/concrete-courtyard-pair.jpg'),
    translucentRainCoat: image('ss26/editorial/translucent-rain-coat.jpg'),
    darkCoatWalk: image('ss26/editorial/dark-coat-walk.jpg'),
    fogCityWalk: image('ss26/editorial/fog-city-walk.jpg'),
    creditPhotography: image('ss26/editorial/credit-photography.jpg'),
    creditStyling: image('ss26/editorial/credit-styling.jpg'),
    creditCasting: image('ss26/editorial/credit-casting.jpg'),
    creditHairMakeUp: image('ss26/editorial/credit-hair-make-up.jpg'),
    creditLocation: image('ss26/editorial/credit-location-airfield.jpg'),
    storeBerlin: image('ss26/editorial/store-berlin.jpg'),
    storeTokyo: image('ss26/editorial/store-tokyo.jpg'),
    storeNewYork: image('ss26/editorial/store-new-york.jpg'),
    reDyedSwatches: image('ss26/editorial/about-re-dyed-swatches.jpg'),
    materialsLoom: image('ss26/editorial/materials-loom.jpg'),
    materialsShell: image('ss26/editorial/materials-shell-concrete.png'),
    aboutHero: image('ss26/editorial/about-hero.png'),
    neonDoorway: image('ss26/editorial/neon-doorway.jpg'),
    rainOnGlass: image('ss26/editorial/rain-on-glass.jpg'),
    coatPastShopfront: image('ss26/editorial/coat-past-shopfront.jpg'),
    coatAndCapShadow: image('ss26/editorial/coat-and-cap-shadow.jpg'),
    wetAvenue: image('ss26/editorial/wet-avenue.jpg'),
    allBlackPortrait: image('ss26/editorial/all-black-portrait.jpg'),
    leatherJacketStudio: image('ss26/editorial/leather-jacket-studio.jpg'),
    leatherJacketWall: image('ss26/editorial/leather-jacket-wall.jpg'),
    washedDenimLook: image('ss26/editorial/washed-denim-look.jpg'),
    flaredDenimLook: image('ss26/editorial/flared-denim-look.jpg')
}

/** Product photography, used where a section previews a specific piece. */
export const productShots = {
    utilityBomberDetail: image('ss26/shop/utility-bomber-detail.jpg'),
    mohairCardiganDetail: image('ss26/shop/mohair-cardigan-detail.jpg'),
    choreJacketDetail: image('ss26/shop/denim-chore-jacket-detail.jpg'),
    archiveToteDetail: image('ss26/shop/archive-tote-detail.jpg')
}
